import { render, staticRenderFns } from "./HeroHeader.vue?vue&type=template&id=2c3ac0a8&scoped=true"
import script from "./HeroHeader.vue?vue&type=script&lang=js"
export * from "./HeroHeader.vue?vue&type=script&lang=js"
import style0 from "./HeroHeader.vue?vue&type=style&index=0&id=2c3ac0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3ac0a8",
  null
  
)

export default component.exports